module.exports = __webpack_public_path__ + "img/ios.e636aaa1.svg";